import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgClose from '../../../../play-core/icons/Close';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../play-core/styles/z-index';
import { Button } from '../ClickableComponents/Button';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Banner = ({
  title,
  text,
  link,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsxs(BannerContainer, {
      children: [/*#__PURE__*/_jsxs(Content, {
        children: [/*#__PURE__*/_jsxs(BannerTitle, {
          children: [title, !text && link && /*#__PURE__*/_jsx(BannerLink, {
            href: link.url,
            children: link.title
          })]
        }), text && /*#__PURE__*/_jsxs(BannerText, {
          children: [text, link && /*#__PURE__*/_jsx(BannerLink, {
            href: link.url,
            children: link.title
          })]
        })]
      }), /*#__PURE__*/_jsx(CloseButton, {
        type: "icon",
        icon: /*#__PURE__*/_jsx(SvgClose, {}),
        ariaLabel: t('global.close'),
        colorSet: {
          iconColor: Colors.WHITE,
          backgroundColor: 'transparent',
          hoverBackgroundColor: 'transparent',
          activeBackgroundColor: 'transparent'
        },
        onClick: () => onClose()
      })]
    })
  });
};
const BannerContainer = styled.div.withConfig({
  displayName: "Banner__BannerContainer",
  componentId: "sc-167dm5w-0"
})(["position:sticky;bottom:0;left:0;right:0;z-index:", ";background-color:", ";display:flex;justify-content:center;overflow:hidden;"], zIndex.aboveHeader, Colors.SRF_c91024);
const Content = styled.div.withConfig({
  displayName: "Banner__Content",
  componentId: "sc-167dm5w-1"
})(["display:flex;flex-direction:column;max-width:624px;margin:24px;word-break:break-word;", "{margin-right:56px;}"], Viewports.for('small'));
const BannerLink = styled.a.withConfig({
  displayName: "Banner__BannerLink",
  componentId: "sc-167dm5w-2"
})(["", ";color:", ";text-decoration:underline;margin-left:4px;"], Fonts.regular(14), Colors.WHITE);
const BannerTitle = styled.h3.withConfig({
  displayName: "Banner__BannerTitle",
  componentId: "sc-167dm5w-3"
})(["", ";color:", ";margin:0;", "{", ";}"], Fonts.medium(16), Colors.WHITE, BannerLink, Fonts.regular(16));
const BannerText = styled.p.withConfig({
  displayName: "Banner__BannerText",
  componentId: "sc-167dm5w-4"
})(["", ";color:", ";line-height:20px;margin:8px 0 0 0;"], Fonts.light(14), Colors.WHITE);
const CloseButton = styled(Button).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "Banner__CloseButton",
  componentId: "sc-167dm5w-5"
})(["position:absolute;right:8px;top:2px;"]);